export const loadPasswordPolicy = (): Promise<
  typeof import('@nest-react/lib')
> => import('@nest-react/lib');
